import { useContext } from 'react';

import Card3DAnimated from '@/components/game/3d/object/card/Card3DAnimated';
import { stepStackedCardYFiber } from '@/const/magicNumber';
import { GameContext, ViewContext } from '@/state/contexts';
import { getCardTexturePath } from '@/util/card';

const DiscardPileBuilderAnimated = () => {
	const { discardPile }: any = useContext(GameContext);
	const { setShowDiscardPileModal }: any = useContext(ViewContext);

	return (
		<>
			{discardPile.map((cardId, index) => {
				const texturePath = getCardTexturePath(cardId);

				return (
					<Card3DAnimated
						key={`key-discardpile-${cardId}`}
						id={`id-discardpile-${cardId}`}
						texturePath={texturePath}
						position_x={5}
						position_z={2}
						position_y_start={50}
						position_y_final={stepStackedCardYFiber * index + 5}
						onClick={() => setShowDiscardPileModal(true)}
					/>
				);
			})}
		</>
	);
};

export default DiscardPileBuilderAnimated;

/*
					return (
						<Card3DComposed
							key={card.id}
							id={card.id}
							texturePath={texturePath}
							position_start={[5, 50, 2]}
							position_end={[5, 0.12 * index + 5, 2]}
							onClick={() =>
								setShowDiscardPileModal(true)
							}
						/>
					);
					*/
